import React, { useEffect } from "react";

export default function Size720X300({
  banner,
  title,
  description,
  titleButton,
  colorButton,
  colorTextButton,
  imageBrand,
  logoBrand,
  backgroundColorDetailsArea,
  borderRadiusButton,
}) {
  useEffect(() => {
    document.querySelector("#title").innerHTML = title;
  }, [title]);
  useEffect(() => {
    document.querySelector("#description").innerHTML = description;
  }, [description]);

  return (
    <>
      <div
        className="border border-1 d-flex flex-row position-relative"
        id="preview-banner"
        style={{
          width: `${banner.size.width}px`,
          height: `${banner.size.height}px`,
        }}
      >
        <div
          style={{
            width: `${banner.cropSize.width}px`,
            height: `${banner.cropSize.height}px`,
          }}
        >
          <img
            style={{
              width: `${banner.cropSize.width}px`,
              height: `${banner.cropSize.height}px`,
            }}
            src={
              imageBrand
                ? imageBrand
                : "/assets/img/preview-image-banner-generator.svg"
            }
          />
        </div>
        <div
          className="d-flex flex-column align-items-center justify-content-around w-100 p-2"
          style={{
            backgroundColor: backgroundColorDetailsArea,
          }}
        >
          <div id="title" className="w-100"></div>
          <div className="w-100" id="description"></div>
          <span>
            <span
              className="btn btn-success px-2 py-1"
              id="view-button-in-preview-section"
              style={{
                height: "30px",
                backgroundColor: colorButton,
                borderColor: colorButton,
                borderRadius: `${borderRadiusButton}px`,
                color: colorTextButton,
              }}
            >
              {titleButton ? titleButton : "مشاهده"}
            </span>
          </span>
          {logoBrand && (
            <span
              className="position-absolute"
              style={{
                top: banner.positionLogo.top + "px",
                left: banner.positionLogo.left + "px",
              }}
            >
              <img src={logoBrand} />
            </span>
          )}
        </div>
      </div>
    </>
  );
}
